module.exports = __webpack_public_path__ + "static/media/ChaloMenu 2.d79ffdce.jpg";